import React, { useState } from "react";
import {
  AppBar,
  Button,
  Tab,
  Tabs,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DrawerComp from "../Drawer/Drawer.js";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { URL } from "../../constants/constant.js";
var axios = require("axios");

const Navbar = ({ role }) => {
  const [value, setValue] = useState(0); //select Profiles by default
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  const handleLogout = () => {
    let loggedInUserDetails = JSON.parse(
      localStorage.getItem("loggedInUserDetails")
    );
    let email = loggedInUserDetails["emailId"];

    //call logout api here
    var config = {
      method: "post",
      url:
        URL.demystify_url + "auth/demystifyLoggedOut?email=" + email,
      headers: {},
    };

    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data));
        if (response.data.success) {
          localStorage.clear();
          window.location.href = "/sso";
        } else {
          alert("Logout Failed. Message: " + response.data.Message);
        }
      })
      .catch(function (error) {
        console.log(error);
        alert("Logout Failed. Message: " + error);
      });
  };

  return (
    <React.Fragment>
      <AppBar sx={{ background: "#063970", height: "80px" }}>
        <Toolbar>
          <img
            alt="Medibuddy"
            src="../../../images/medibuddyWithName.svg"
            style={{
              height: 30,
              backgroundColor: "#fff",
              padding: 5,
              borderRadius: 10,
            }}
          />
          {isMatch ? (
            <>
              <DrawerComp />
            </>
          ) : (
            <>
              <Tabs
                sx={{ marginLeft: "auto" }}
                indicatorColor="secondary"
                textColor="inherit"
                value={value}
                onChange={(e, value) => {
                  //console.log(value);
                  setValue(value);
                }}
              >
                <Tab
                  as={Link}
                  to={"/profiles"}
                  label="PROFILES"
                  sx={{
                    marginRight: 3,
                    lineHeight: 3.5,
                    textDecoration: "none",
                  }}
                />
                <Tab
                  as={Link}
                  to={"/docs"}
                  label="DOCUMENT LIST"
                  sx={{
                    marginRight: 3,
                    lineHeight: 3.5,
                    textDecoration: "none",
                  }}
                />
                <Tab
                  as={Link}
                  to={"/corporatecaselist"}
                  label="CASELIST"
                  sx={{
                    marginRight: 3,
                    lineHeight: 3.5,
                    textDecoration: "none",
                  }}
                />
                <Tab
                  as={Link}
                  to={"/insurancecaselist"}
                  label="INSURANCE"
                  sx={{
                    marginRight: 3,
                    lineHeight: 3.5,
                    textDecoration: "none",
                  }}
                />
                <Tab
                  as={Link}
                  to={"/download"}
                  label="DOWNLOAD"
                  sx={{
                    marginRight: 3,
                    lineHeight: 3.5,
                    textDecoration: "none",
                    display: role == "Admin" ? "" : "none",
                  }}
                />
                <Tab
                  as={Link}
                  to={"/dashboard"}
                  label="DASHBOARD"
                  sx={{
                    marginRight: 3,
                    lineHeight: 3.5,
                    textDecoration: "none",
                  }}
                />
                <Tab
                  as={Link}
                  to={"/packageMapping"}
                  label="ADMIN"
                  sx={{
                    marginRight: 3,
                    lineHeight: 3.5,
                    textDecoration: "none",
                    display: role == "Admin" ? "" : "none",
                  }}
                />
                {/* <Tab as={Link} to={"/apiresponses"} label="API RESPONSE" sx = {{ marginRight: 3, lineHeight: 3.5, textDecoration: 'none'  }} /> */}
              </Tabs>

              <Button
                sx={{
                  marginLeft: "auto",
                  visibility: isLoggedIn ? "visible" : "hidden",
                }}
                variant="contained"
                onClick={handleLogout}
              >
                Logout
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

export default Navbar;
